module.exports = __webpack_public_path__ + "img/sds-logo.67f13415.png";